import React from 'react';
import { Button } from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/81221907834b54707d36c321a6346460.jpg')`
        }}
      >
        <div className="absolute inset-0 bg-black/50"></div>
      </div>

      <div className="relative z-10 container mx-auto px-4">
        <div className="max-w-4xl mx-auto text-center text-white">
          <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
            Tired Of Cleaning Gutters?
          </h1>
          <p className="text-xl md:text-2xl mb-8 leading-relaxed">
            Simple Gutter Guards That Actually Work - Easy Install, Low Cost, Minimal Maintenance
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-12">
            <Button size="lg" className="text-lg px-8 py-4" href="https://www.gutterbrush.com/pages/request-a-free-gutterbrush-quote" target="_blank" rel="noopener noreferrer">
              Get Free Quote
            </Button>
          </div>

          {/* Key Benefits */}
          <div className="grid grid-cols-1 md:grid-cols-4 gap-6 mt-16">
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shield-check-line text-white text-xl"></i>
              </div>
              <h3 className="font-bold mb-2">Since 2004</h3>
              <p className="text-sm">Made in USA</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-tools-line text-white text-xl"></i>
              </div>
              <h3 className="font-bold mb-2">Easy Install</h3>
              <p className="text-sm">Do it yourself</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-money-dollar-circle-line text-white text-xl"></i>
              </div>
              <h3 className="font-bold mb-2">$300-$400</h3>
              <p className="text-sm">Most homes</p>
            </div>
            
            <div className="bg-white/10 backdrop-blur-sm rounded-lg p-6">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-ruler-line text-white text-xl"></i>
              </div>
              <h3 className="font-bold mb-2">6 Diameters</h3>
              <p className="text-sm">2.25" to 8.0"</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
